export default __webpack_public_path__ + "static/media/picture-ic.e9a8d8af.svg";